import React from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import { Toaster } from "react-hot-toast";

import "./App.css";
import ScrollToTop from "./components/utils/ScrollToTop";

import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./pages/home/Home";
import About from "./pages/About";
import Courier from "./pages/Courier";
import Haulage from "./pages/Haulage";
import TransitHotels from "./pages/TransiHotel";
import Terminal from "./pages/Terminal";
import Routing from "./pages/Route";
import Contact from "./pages/Contact";
import Booking from "./pages/Booking";
import PassengerDetails from "./pages/PassengerDetails";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="z-[30]">
        <Toaster />
      </div>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/booking" element={<Booking />} />
        <Route path="/passenger-details" element={<PassengerDetails />} />
        <Route path="/courier" element={<Courier />} />
        <Route path="/haulage" element={<Haulage />} />
        <Route path="/transit-hotel" element={<TransitHotels />} />
        <Route path="/terminal" element={<Terminal />} />
        <Route path="/routes" element={<Routing />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
